<ion-header>
  <cc-header [info]="header" (iconClicked)="addFailure()">
    <ion-back-button [text]="''"></ion-back-button>
  </cc-header>
</ion-header>


<ion-content>

  <ion-list *ngIf="selectedFailures.length">
    <ion-text color="primary">
      <h1 class="ion-padding-start list">{{ 'requirement-form.Lista de fallas a reportar'  | translate }}</h1>
      <p class="ion-padding-start ion-padding-end descrip">{{ 'requirement-form.Adjunte imágenes y observaciones para detallar mejor las fallas'  | translate }}</p>
    </ion-text>

    <cc-addedd-flaw #failures *ngFor="let fail of selectedFailures" [flaw]="fail"
      [failureIdentifier]="fail.configId+''+fail.detailId" (deletedFlawId)="deleteFlaw($event)"></cc-addedd-flaw>
  </ion-list>

  <div *ngIf="!selectedFailures.length" class="ion-padding ion-margin-top ion-text-center">
    <!-- Agregue las fallas encontradas a su solicitud -->
    {{ 'requirement-form.No hay fallas registradas'  | translate }}
  </div>
</ion-content>


<ion-footer *ngIf="selectedFailures.length">
  <ion-text *ngIf="checkIfFiles()" color="dark">
    <p class="img-msg">{{ 'requirement-form.Mantenga presionado para eliminar una imagen, pulse para ampliar'  | translate }}</p>
  </ion-text>

  <ion-toolbar>
    <ion-grid class="ion-no-padding" fixed>
      <ion-row>
        <ion-col size="6">
          <ion-button (click)="addFailure()"
            class="ion-no-margin footer-button" fill="clear" expand="block" color="primary">
            {{ 'requirement-form.Agregar fallas'  | translate }}
          </ion-button>
        </ion-col>
        <ion-col class="ion-no-padding" size="6">
          <ion-button [disabled]="createButtonDisabled" (click)="confirmRequestCreation()"
            class="ion-no-margin footer-button" expand="block" color="success">
            {{ 'requirement-form.Enviar solicitud'  | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>